import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './menu.css';

import ChevronDown from '../../assets/chevron-down.svg'; // Adjust path if needed

function LanguageDropdown() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = {
    en: 'English',
    sv: 'Svenska',
    da: 'Dansk',
    de: 'Deutsch',
    es: 'Español',
    fr: 'Français',
    it: 'Italiano',
    fi: 'Suomi',
    no: 'Norsk',
    tr: 'Türkçe',
    pl: 'Polski',
  };

  const currentLang = i18n.language;

  const changeLanguage = (newLang) => {
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
    const url = new URL(window.location.href);
    url.searchParams.set('lang', newLang);
    window.history.replaceState(null, '', url);
    setOpen(false);
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="lang-dropdown" ref={dropdownRef}>
      <button onClick={() => setOpen(!open)} className="lang-button">
        <img className='flag' src={`/assets/${currentLang}.svg`} alt={currentLang} />
        <img
          src={ChevronDown}
          alt="Chevron Down"
          className={`chevron-icon ${open ? 'rotate' : ''}`}
        />

      </button>
      {open && (
        <div className="lang-list">
          {Object.entries(languages).map(([code, label]) => (
            <div key={code} className="lang-item" onClick={() => changeLanguage(code)}>
              <img className='flag' src={`/assets/${code}.svg`} alt={code} />
              {label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageDropdown;
